export default __webpack_public_path__ + "static/media/image27tum.51031446.jpg";